var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 15 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M10 1.33333C9.46957 1.33333 8.96101 1.5442 8.58594 1.91927C8.21087 2.29434 8 2.8029 8 3.33333V10.3581C8.40202 10.1259 8.86104 10 9.33333 10H13.3333V1.33333H10ZM1.33333 10H5.33333C5.80562 10 6.26465 10.1259 6.66667 10.3581V3.33333C6.66667 2.8029 6.4558 2.29434 6.08073 1.91927C5.70566 1.5442 5.1971 1.33333 4.66667 1.33333H1.33333V10ZM14.6667 10C14.6667 10.3536 14.5261 10.6927 14.276 10.9427C14.026 11.1928 13.687 11.3333 13.3333 11.3333H9.33333C8.97971 11.3333 8.64067 11.4739 8.39063 11.724C8.14058 11.974 8 12.313 8 12.6667C8 13.0349 7.70152 13.3333 7.33333 13.3333C6.96514 13.3333 6.66667 13.0349 6.66667 12.6667C6.66667 12.313 6.52609 11.974 6.27604 11.724C6.02599 11.4739 5.68696 11.3333 5.33333 11.3333H1.33333C0.979713 11.3333 0.640674 11.1928 0.390625 10.9427C0.140576 10.6927 0 10.3536 0 10V1.33333C0 0.979711 0.140576 0.640674 0.390625 0.390625C0.640674 0.140576 0.979711 0 1.33333 0H4.66667C5.55072 0 6.39832 0.351441 7.02344 0.976562C7.13575 1.08888 7.23915 1.20837 7.33333 1.33398C7.42751 1.20837 7.53091 1.08888 7.64323 0.976562C8.26835 0.351441 9.11595 0 10 0H13.3333C13.687 0 14.026 0.140576 14.276 0.390625C14.5261 0.640674 14.6667 0.979713 14.6667 1.33333V10Z",
          fill: _vm.fill
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }